<div *ngIf="isloader" class="h-100 w-100 padt-5">
    <mat-progress-bar [mode]="'indeterminate'">
    </mat-progress-bar>
</div>
<mat-drawer-container class="example-container" hasBackdrop="true" class="default-size">
    <mat-drawer #drawer mode="over" position="end" disableClose="false">
        <div class="d-grid justify-content-center align-items-center">
            <div class="d-flex">
                <span (click)="drawer.toggle();closeDrawer()" class="collapse-me">></span>
                <div class="d-flex justify-content-center w-100">
                    <h1>{{displayTimeLineDetails?.tagId}}</h1>
                </div>
            </div>
            <div class="d-flex justify-content-center padding-bottom">&nbsp;(<span class="tat-tile">TAT</span>
                -&nbsp;{{displayTimeLineDetails?.tat}}&nbsp;<span class="tat-tile">|</span>&nbsp;<span
                    class="tat-tile">Life
                    Cycle
                    Duration</span>&nbsp;-&nbsp;{{displayTimeLineDetails?.duration?displayTimeLineDetails?.duration:'NA'}})
            </div>
            <div class="d-flex justify-content-center">
                <span class="tat-tile"> Destination: </span> <span class="jsonElipses"
                    [matTooltip]="displayTimeLineDetails?.destination">&nbsp;{{displayTimeLineDetails?.destination}}</span>
            </div>
            <div class="d-flex justify-content-center padding-bottom">
                <span class="tat-tile">Tagged By:</span> <span class="jsonElipses"
                    [matTooltip]="displayTimeLineDetails?.taggedBy">&nbsp;{{displayTimeLineDetails?.taggedBy}}</span>
            </div>


            <!-- Time Line Here -->
            <div class="xyz" *ngFor="let timeLine of timeLineData; let i = index">
                <div class="classy-timeline ">
                    <div style="--dot-color-var:{{timeLine?.color}};" class="timeline-decorator d-flex dot-seperator"
                        [ngClass]="{'visibility': i % 2 !== 0}">
                        <div class="timeline-content">
                            <div class="classy-timeline-subject">{{timeLine?.name | titlecase}}</div>
                            <div class="d-flex min-width-90 align-data-end">
                                <div class="story-location pr-2"></div>
                                <div class="happening-time pl-2 tagged-date" *ngIf="timeLine?.action === 'tag'">
                                    {{timeLine?.at | date: 'dd/MM/YY hh:mm:ss aaa'}}</div>
                                <div class="happening-time pl-2" *ngIf="timeLine?.action !== 'tag'">{{timeLine?.at |
                                    date:'hh:mm:ss aaa':'en-US'}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="dot-seperator-before timeline-decorator-before d-flex "
                        style="--dot-color-var:{{timeLine?.color}};" [ngClass]="{'visibility': i % 2 === 0}">
                        <div class="timeline-content-before">
                            <div class="classy-timeline-subject">{{timeLine?.name | titlecase}}</div>
                            <div class="d-flex min-width-90 align-data-start">
                                <div class="story-location"></div>
                                <div class="happening-time tagged-date" *ngIf="timeLine?.action === 'tag'">
                                    {{timeLine?.at | date: 'dd/MM/YY hh:mm:ss aaa'}}</div>
                                <div class="happening-time" *ngIf="timeLine?.action !== 'tag'">{{timeLine?.at |
                                    date:'hh:mm:ss aaa':'en-US'}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--time line dies here-->

        </div>
    </mat-drawer>
    <mat-drawer-content>
        <p class="historyTime">Last Updated On: {{refreshTime }}</p>
        <app-common-table [tableData]="masterMonotainerHistory" [columnHeader]="columnHeader" pageType="widgetAlerts"
            class="app-common-table" [actionPermission]="{lifeCycle:true,pagination:false}"
            (tableAction)="tableAction($event);drawer.toggle();">
        </app-common-table>
        <div class="pagination-container w-100" *ngIf="masterMonotainerHistory.length">
            <ul *ngIf="pager.pages && pager.pages.length > 1" class="pagination mt-2 pb-2 cursor">
                <li [ngClass]="{'pagination-disable':pager.currentPage === 1}" class="page-item first-item">
                    <a (click)="onPaginateChange(1)" class="page-link" data-toggle="tooltip" title="First"><em
                            class="fas fa-angle-double-left mr-2"></em></a>
                </li>
                <li [ngClass]="{'pagination-disable':pager.currentPage === 1}" class="page-item previous-item">
                    <a (click)="onPaginateChange(pager.currentPage - 1)" class="page-link" data-toggle="tooltip"
                        title="Previous"><em class="fas fa-angle-left mr-2"></em></a>
                </li>
                <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}"
                    class="page-item number-item">
                    <a (click)="onPaginateChange(page)" class="page-link">{{page}}</a>
                </li>
                <li [ngClass]="{'pagination-disable':pager.isLastPage}" class="page-item next-item">
                    <a (click)="onPaginateChange(pager.currentPage + 1)" class="page-link" data-toggle="tooltip"
                        title="Next"><em class="fas fa-angle-right mr-2"></em></a>
                </li>
                <li [ngClass]="{'pagination-disable':pager.isLastPage}" class="page-item last-item">
                    <a (click)="onPaginateChange(pager.endPage)" class="page-link" data-toggle="tooltip"
                        title="Last"><em class="fas fa-angle-double-right mr-2"></em></a>
                </li>
            </ul>
        </div>
    </mat-drawer-content>
</mat-drawer-container>